function startCompanionProducts(options) {
  var defaults = {
    button: '.add-to-cart',
    product: 'input[name="id"]',
    quantity: 'input[name="quantity"]',
    clickThrough: false
  };

  var settings = Object.assign(defaults, options);
  var bypass = false;

  function findForm(elm) {
    if (elm === undefined || elm === null) {
      throw new Error('findForm hit a dead end!')
    }

    if (elm.tagName !== 'FORM') {
      return findForm(elm.parentNode)
    }

    return elm
  }

  var button = document.querySelector(settings.button);
  var selectBoxes = Array.prototype.slice.call(
    document.querySelectorAll('.companion-variant')
  );

  function handleButtonClick(evt) {
    var companions = document.querySelector('.companion-products');
    if (bypass || companions === null) return

    evt.preventDefault();

    var form = findForm(button);
    var primaryProd = form.querySelector(settings.product).value;
    var qtyValue = form.querySelector(settings.quantity).value;
    var checkedNodes = form
      .querySelectorAll('.companion-product .product-checkbox:checked');
    var upsells = Array.prototype.slice.call(checkedNodes);

    var initialPayload = settings.clickThrough ? [] : [{
      id: primaryProd,
      quantity: Number(qtyValue)
    }];

    var payload = upsells.reduce(function(items, item) {
      return items.concat({
        id: item.dataset.product,
        quantity: 1
      })
    }, initialPayload)

    theme.cart._updateCart({
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        items: payload
      }
    }).catch(function(XHR) {
      var $form = $('#'+form.getAttribute('id'));
      var streamlineProduct = new theme.AjaxProduct($form);
      window.slp = streamlineProduct
      window.XHR = XHR
      streamlineProduct.error(XHR);
    })
  }

  function handleVariantSelector(box) {
    var product = box.dataset.product;
    var checkbox = document.querySelector('#companion-'+product);
    checkbox.dataset.product = box.value;
  }

  selectBoxes.forEach(function(box) {
    box.addEventListener('change', function() {
      handleVariantSelector(box);
    });
  });

  button.addEventListener('click', handleButtonClick);
}

window.initProductCompanions = function() {
  startCompanionProducts({ product: '[name="id"]' });
}